


































































































































































import { Component, Vue } from 'vue-property-decorator';
import firebase from "firebase";
import axios from "axios";
import AppLayout from "@/components/AppLayout.vue";
import { db, Keyword, Campaign, KeywordPlanner, Ad } from '../db';

@Component({
  components: { AppLayout }
})
export default class Home extends Vue {
  private url = "https://scrapper-sancho-v1.herokuapp.com/";
  //private url = "http://localhost:8000/";
  private user: any = null;
  private showCreateCampaign = false;
  private showPublishCampaign = false;
  private showMessage = false;
  private initLoading = true;
  private loading = false;
  private message = '';
  private siteName = '';
  private siteURL = '';
  private customerID = '8741859343';
  private campaigns: Campaign[] = [];
  // eslint-disable-next-line @typescript-eslint/camelcase
  private currentCampaign: {[key: string]: any} = {description: null, description2: null, customer_id: null };
  private activeStep = 'first';
  private keywordStep = false;
  private relevanceStep = false;
  private adsSteps = false;


  async csvExport(campaign: Campaign){
    const nCampaign = {
      name: campaign.name,
      url: campaign.url,
      keywords: campaign.keywords,
      ads: campaign.ads,
    }
    const { data } = await axios.post(
        'https://scrapper-sancho-v1.herokuapp.com/api/get_csv/', nCampaign
    );
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', campaign.name+'.csv');
    document.body.appendChild(link);
    link.click();
  }
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.loadCampaigns();
      } 
    });
  }
  async keywordState(campaign: Campaign){
    try {
      axios.post(this.url+'make_keywords/', { websiteId: campaign.scrappId } );
      const grepStat = setInterval(async () => {
        const{ data } = await this.getStates(campaign.scrappId);
        if(data.keyworded == 'keyworded'){
          clearInterval(grepStat);
          this.printNgrams(campaign);
          return;
        }
        this.showMessage = true;
        this.message = 'Seguimos analizando el lenguaje del sitio, porfavor espere';
      }, 5000);
    } catch (error) {
      console.log(error)
      this.showMessage = true;
      this.message = 'Ha ocurrido un error, por favor intenta más tarde';
      this.loading = false;
    }
  }
  async printNgrams( campaign: Campaign){
    const {data} = await axios.post(this.url+'get_keywords/', {websiteId: campaign.scrappId})
    const keywords: Keyword[] = [];
    Object.keys(data.ngrams).forEach(ngramKey =>  {
      const ngrams: [string,number][] = data.ngrams[ngramKey];
      return ngrams.forEach( (ngram) => {
        if (ngram[0]) {            
          keywords.push({ name: ngram[0], frequency: ngram[1] })
        }
      })
    })
    if (keywords.length) {
      campaign.keywords = keywords;
      campaign.scraped = true;
      campaign.step = 2;
      this.updateCampaign(campaign)
    }
    this.loading = false;
  }
  async loadCampaigns() {
    db.collection('campaigns')
      .where("creatorId", "==", this.user.uid)
      .where('status', '==', true)
      .get()
      .then(querySnapshot => {
        const campaigns = querySnapshot.docs.map(doc => {
          return { id: doc.id, ...doc.data() }
        })
        this.campaigns = campaigns as Campaign[];
        this.currentCampaign = {...campaigns[0], ...this.currentCampaign};
        this.initLoading = false;
      })
  }
  async createCampaign() {
    try {
      this.loading = true;
      /* const { data } = await axios.post(
        `https://sancho-254100.uc.r.appspot.com/api/websites/`,
        // eslint-disable-next-line @typescript-eslint/camelcase
        { name: this.siteName, base_url: this.siteURL }
      ); */
      const webScrap = await axios.post(this.url+'save_website/',
        { name: this.siteName, baseUrl: this.siteURL },
      );
      if(!webScrap.data.ok){
        throw webScrap.data.reason;
      }      
      const customer = this.customerID.replace(' ', ''); //delete spaces
      db.collection('campaigns').add({
        name: this.siteName,
        url: this.siteURL,
        creatorId: this.user.uid,
        scraped: false,
        //websiteId: data.website,
        customerId: customer,
        scrappId: webScrap.data.websiteId,
        step: 1,
        status: true
      });
      this.loadCampaigns();
      this.loading = false;
      this.showCreateCampaign = false;
    } catch (error) {
      this.showMessage = true;
      this.message = '¡Error! ' + error; 
      this.loading = false;
    }
  }
  async updateCampaign(campaign: Campaign){
    db.collection('campaigns')
      .doc(campaign.id)
      .set(campaign)
      .then(() => {
        console.log('campaign updated!')
      });
  }
  async getKeywords(campaign: Campaign, size = 5) {
    try {
      this.loading = true;
      this.showMessage = true;
      this.message = 'Iniciando proceso de indexado, porfavor espere';
      const {data} = await this.getStates(campaign.scrappId);
      if(data.scrapped == "scrapped"){
        console.log('sitio scrapeado, saltando a creación de ngrams');
        if(data.keyworded == 'keyworded'){
          console.log('ya hay keywords, saltar a su renderizado');
          this.printNgrams(campaign);
        }
        else{
          this.keywordState(campaign);
        }
        return;
      }
      console.log('sitio no scrappeado, iniciando');
      axios.post(this.url+'scrapper/', {websiteId: campaign.scrappId})      
      const grepStat = setInterval(async () => {
        const {data} = await this.getStates(campaign.scrappId);
        if(data.scrapped == 'scrapped'){ 
          clearInterval(grepStat);
          this.showMessage = true;
          this.message = 'Iniciando analisis de lingüístico';
          this.keywordState(campaign);
        }
        this.showMessage = true;
        this.message = 'Estamos procesando el sitio, por favor espere';
      }, 5000);
    } catch (error) {
      console.log(error)
      this.showMessage = true
      this.message = 'Ha ocurrido un error, por favor intenta más tarde'
      this.loading = false;
    }
  }
  async getStates(websiteId: number){
    return await axios.post(this.url+'get_states/', { websiteId } );
  }
  activeTab(tabId: string) {
    console.log('activeTab is', tabId)
  }
  selectKeyword(keywords: Keyword[]) {
    this.currentCampaign.keywords = keywords;
  }
  selectKeywordPlanner(keywordPlanners: KeywordPlanner[]) {
    this.currentCampaign.keywordPlanners = keywordPlanners;
  }
  selectAds(ads: Ad[]) {
    this.currentCampaign.ads = ads;
  }
  async deleteCampaign(campaign: Campaign) {
    try{
      this.loading = true;
      campaign.status = false;
      const {data} = await axios.post(`${this.url}delete_website/`,
      {websiteId: campaign.scrappId, customerId: campaign.customerId, campaignId: campaign.campaignId || false});
      if(!data.ok){ throw data.reason; }
      await db.collection('campaigns').doc(campaign.id).set(campaign);
      this.loadCampaigns();
      this.showMessage = true;
      this.message = 'Campaña eliminada adecuadamente';
      this.loading = false;
    }
    catch(e){
      console.log(e)
      this.showMessage = true;
      this.message = 'Ha ocurrido un error, por favor intenta más tarde';
      this.loading = false;
    }
  }
  async sendKeywords(campaign: Campaign) {
    try {
      this.loading = true;
      const selectedKeywords = (this.currentCampaign.keywords || [])
        .map((kw: Keyword) =>  {
          return {name: kw.name, frequency: kw.frequency};
        });
      const { data } = await axios.post(
        `${this.url}get_planner/`,
        { keywords: selectedKeywords.map((kw: Keyword)=> kw.name), customerId: campaign.customerId}
      );
      const kwPlanners: KeywordPlanner[] = []
      data.plannerResult.forEach( (kwPlan: [string,number,string]) =>  {
        if (kwPlan[0] && kwPlanners.length < 50) {            
          kwPlanners.push({
            text: kwPlan[0],
            avgMonthlySearches: kwPlan[1],
            competitionValue: kwPlan[2]
          })
        }
      })
      if (kwPlanners.length) {
        campaign.keywordPlanners = kwPlanners;
        campaign.selectedKeywords = selectedKeywords;
        this.activeStep = 'second'
        this.keywordStep = true;
        this.updateCampaign(campaign)
      }
      this.loading = false;
    } catch (error) {
      console.log(error)
      this.showMessage = true
      this.message = 'Ha ocurrido un error, por favor intenta más tarde'
      this.loading = false;
    }
  }
  async sendKeywordPlanner(campaign: Campaign) {
    try {
      this.loading = true;
      const selectedKeywordP = (this.currentCampaign.keywordPlanners || [])
        .map((kwp: KeywordPlanner) => {
          return {
            text: kwp.text, 
            avgMonthlySearches: kwp.avgMonthlySearches, 
            competitionValue: kwp.competitionValue
          }
        });
      const { data } = await axios.post(
        `${this.url}campaign/`,
        // eslint-disable-next-line @typescript-eslint/camelcase
        { name: campaign.name, website_id: campaign.url, ad_groups: selectedKeywordP.map(
          (kwp: KeywordPlanner) => kwp.text ) }
      );
      campaign.ads = data.ads.map((ad: {url: string; headline_1: string; headline_2: string; headline_3: string; campaign_id: number; ad_group_id: number}) => {
        return {
          url: ad.url,
          // eslint-disable-next-line @typescript-eslint/camelcase
          headline_1: ad.headline_1,
          // eslint-disable-next-line @typescript-eslint/camelcase
          headline_2: ad.headline_2,
          // eslint-disable-next-line @typescript-eslint/camelcase
          headline_3: ad.headline_3,
          // eslint-disable-next-line @typescript-eslint/camelcase
          campaign_id: ad.campaign_id,
          // eslint-disable-next-line @typescript-eslint/camelcase
          ad_group_id: ad.ad_group_id
        }
      });
      campaign.selectedPlanner = selectedKeywordP;
      this.activeStep = 'third'
      this.relevanceStep = true;
      this.updateCampaign(campaign)
      this.loading = false;
    } catch (error) {
      console.log(error)
      this.showMessage = true;
      this.message = 'Ha ocurrido un error, por favor intenta más tarde';
      this.loading = false;
    }
  }
  async showCampaign(campaign: Campaign){
    const selectedAds = (this.currentCampaign.ads || []);
    campaign.selectedAds = selectedAds;
    await this.updateCampaign(campaign);
    this.currentCampaign.campaign = campaign;
    this.showPublishCampaign = true;
  }
  async publishCampaign() {
    try {
      this.loading = true;
      const campaign = this.currentCampaign.campaign;
      const { data } = await axios.post(
        `${this.url}create_campaign/`,
        { campaignName: campaign.name, customerId: campaign.customerId,
          description1: this.currentCampaign.description, 
          description2: this.currentCampaign.description2,
          description3: this.currentCampaign.description3, 
          ads: campaign.selectedAds, keywords: campaign.selectedKeywords,
          planner: campaign.selectedPlanner, url: campaign.url }
      );
      if (data.ok == true) {
        campaign.done = true;
        campaign.campaignId = data.message.campaignId;
        this.activeStep = 'first';
        this.updateCampaign(campaign);
        this.showMessage = true;
        this.message = 'La campaña ha sido publicada exitosamente!';
        this.loading = false;
        this.showPublishCampaign = false;       
      } else{
        this.showMessage = true;
        this.message = `Ha ocurrido un error: ${data.reason}`;
        this.loading = false;        
      }
    } catch (error) {
      console.log(error)
      this.showMessage = true;
      this.message = 'Ha ocurrido un error, por favor intenta más tarde';
      this.loading = false;
    }
  }
}
